import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import logo from "../assets/logo.png";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Footer = () => {
  const [footer, setFooter] = useState({
    company_description: "",
    address: "",
    phone: "",
    phone1: "",
    email: "",
    facebook_url: "",
    twitter_url: "",
    linkedin_url: "",
    youtube_url: "",
    disclaimer_text: "",
    copyright_note: "",
  });

  // Fetch footer from backend
  useEffect(() => {
    const fetchFooter = async () => {
      try {
        const { data } = await axios.get(`${API_BASE_URL}/footer/get`);
        if (data) setFooter(data);
      } catch (error) {
        console.error("❌ Error fetching footer data:", error);
      }
    };
    fetchFooter();
  }, []);

  return (
    <footer className="bg-white py-16 px-4 border-t border-gray-100">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo and Company Info */}
          <div className="space-y-4">
            <img
              src={logo}
              alt="HPR Infra Logo"
              className="h-36 sm:h-40 md:h-16 lg:h-40 w-auto object-contain"
            />
            <p className="text-gray-600 text-xs leading-relaxed">
              {footer.company_description ||
                "HPR Infra — real estate developers in South India offering apartments, villas, and HMDA-approved open plots."}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold text-gray-900 mb-4">
              Quick Links
            </h3>
            <div className="space-y-3">
              <Link
                to="/"
                className="block text-blue-600 hover:text-green-600 transition-colors font-medium"
              >
                Home
              </Link>
              <Link
                to="/about"
                className="block text-blue-600 hover:text-green-600 transition-colors font-medium"
              >
                About Us
              </Link>
              <Link
                to="/projects"
                className="block text-blue-600 hover:text-green-600 transition-colors font-medium"
              >
                Projects
              </Link>
              <Link
                to="/career"
                className="block text-blue-600 hover:text-green-600 transition-colors font-medium"
              >
                Career
              </Link>
              <Link
                to="/contact"
                className="block text-blue-600 hover:text-green-600 transition-colors font-medium"
              >
                Contact
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold text-gray-900 mb-4">Contact Us</h3>
            <div className="space-y-3 text-gray-600">
              {footer.address && (
                <div className="flex items-start gap-2">
                  <svg
                    className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <p className="font-medium">{footer.address}</p>
                </div>
              )}

              {footer.phone && (
                <div className="flex items-center gap-2">
                  <svg
                    className="w-5 h-5 text-blue-600 flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                  <a
                    href={`tel:${footer.phone}`}
                    className="hover:text-blue-600 transition-colors"
                  >
                    {footer.phone}
                  </a>
                </div>
              )}
              {footer.phone1 && (
                <div className="flex items-center gap-2">
                  <svg
                    className="w-5 h-5 text-blue-600 flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>

                  <a
                    href={`tel:${footer.phone1}`}
                    className="hover:text-blue-600 transition-colors"
                  >
                    {footer.phone1}
                  </a>
                </div>
              )}
              {footer.email && (
                <div className="flex items-center gap-2">
                  <svg
                    className="w-5 h-5 text-blue-600 flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  <a
                    href={`mailto:${footer.email}`}
                    className="hover:text-blue-600 transition-colors break-all"
                  >
                    {footer.email}
                  </a>
                </div>
              )}
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-lg font-bold text-gray-900 mb-4">Follow Us</h3>
            <div className="flex gap-4">
              {footer.facebook_url && (
                <a
                  href={footer.facebook_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-blue-100 hover:bg-blue-600 text-blue-600 hover:text-white rounded-lg flex items-center justify-center transition-all shadow-sm hover:shadow-md"
                  aria-label="Facebook"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                  </svg>
                </a>
              )}
              {footer.twitter_url && (
                <a
                  href={footer.twitter_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-100 hover:bg-[radial-gradient(circle_at_30%_107%,#fdf49733_0%,#fd594933_45%,#d6249f33_60%,#285AEB33_90%)] text-gray-600 hover:text-pink-600 rounded-lg flex items-center justify-center transition-all duration-300 shadow-sm hover:shadow-md"
                  aria-label="Instagram"
                  aria-label="Twitter"
                >
                 <svg
      className="w-5 h-5"
      viewBox="0 0 24 24"
    >
      <defs>
        <linearGradient id="ig" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#feda75" />
          <stop offset="25%" stopColor="#fa7e1e" />
          <stop offset="50%" stopColor="#d62976" />
          <stop offset="75%" stopColor="#962fbf" />
          <stop offset="100%" stopColor="#4f5bd5" />
        </linearGradient>
      </defs>

      {/* outline box */}
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="5"
        stroke="url(#ig)"
        strokeWidth="2"
        fill="none"
      />

      {/* center circle */}
      <circle
        cx="12"
        cy="12"
        r="4"
        stroke="url(#ig)"
        strokeWidth="2"
        fill="none"
      />

      {/* small dot */}
      <circle cx="17" cy="7" r="1.2" fill="url(#ig)" />
    </svg>
                </a>
              )}
              {footer.linkedin_url && (
                <a
                  href={footer.linkedin_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-blue-100 hover:bg-blue-700 text-blue-600 hover:text-white rounded-lg flex items-center justify-center transition-all shadow-sm hover:shadow-md"
                  aria-label="LinkedIn"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </a>
              )}
              {footer.youtube_url && (
                <a
                  href={footer.youtube_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-red-100 hover:bg-red-600 text-red-600 hover:text-white rounded-lg flex items-center justify-center transition-all shadow-sm hover:shadow-md"
                  aria-label="YouTube"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                </a>
              )}
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        {footer.disclaimer_text && (
          <div className="border-t border-gray-200 pt-8 mb-8">
            <p className="text-gray-500 text-xs leading-relaxed">
              <strong>Disclaimer:</strong> {footer.disclaimer_text}
            </p>
          </div>
        )}

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-600 text-sm">
            {footer.copyright_note || "© 2025 HPR Infra. All Rights Reserved."}
          </p>
          <div className="flex gap-6 text-sm">
            <Link
              to="/privacy-policy"
              className="text-gray-600 hover:text-blue-600 transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-conditions"
              className="text-gray-600 hover:text-blue-600 transition-colors"
            >
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
